import Vue from 'vue';
import http from '../utils/http';

export default {
    state: {
        media: null,
    },
    mutations: {
        loadMedia(state, payload) {
			state.media = payload;
		},
        addMedia(state, payload) {
            let index = state.media.length
			Vue.set(state.media, index, payload)   
        },
        editMedia(state, payload) {
            const item = state.media?.find(m => m.id == payload.id)
            if (item) {
                let index = state.media?.indexOf(item);
                Vue.set(state.media, index, {...item, ...payload })  
            }      
        },
        deleteMedia(state, payload) {
            state.media =  state.media.filter(item => item.id !== payload)
        },
    },
    actions: {
        //fetch all media by game id & round
        async fetchMedia({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/media/game/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const media = await result.data 
                   commit('loadMedia', media)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addMedia({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.post(`/media`, payload);
                
                if (result) {
                   const media = await result.data; 
                   commit('addMedia', media);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async editMedia({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.put(`/media/${payload.id}`, payload);
                
                if (result) {
                   await result.data; 
                   commit('editMedia', payload);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async deleteMedia({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/media/${payload}`);
                commit('deleteMedia', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async mediaTransition({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                await http.get(`/media/transition/${payload.gameId}?round=${payload.round}`);          
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
    },
    getters: {
        media (state) {
            return state.media;
        },
    }
}